import React from 'react';
import { Printer } from 'lucide-react';

/**
 * Global Print Button for ZignaGenix pages.
 *
 * Renders a branded print header (hidden on screen, visible in print)
 * and a neumorphic print button that triggers window.print().
 *
 * @param {string} pageTitle - The title of the current page/report
 * @param {string} [subtitle] - Optional subtitle or context line
 */
export default function PrintButton({ pageTitle, subtitle }) {
  return (
    <>
      {/* Hidden on screen — shown only when printing */}
      <div className="zg-print-header">
        <h1>ZignaGenix Medical Intelligence Platform</h1>
        <h2>{pageTitle}</h2>
        {subtitle && <p>{subtitle}</p>}
        <p className="zg-print-date">Generated: {new Date().toLocaleString()}</p>
      </div>

      {/* On-screen print button */}
      <button
        className="zg-print-btn"
        onClick={() => window.print()}
        title="Print this page"
      >
        <Printer size={15} />
        Print
      </button>
    </>
  );
}
